// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"362":"02837d0e","490":"bcff9977"}[chunkId] + ".js";
};